export const aiLogos = [
  { target: 'character-ai', altText: 'Character AI' },
  { target: 'imbue', altText: 'Imbue' },
  { target: 'anthropic', altText: 'Anthropic' },
  { target: 'deepmind', altText: 'DeepMind' },
  { target: 'stanford', altText: 'Stanford' },
  { target: 'nyu', altText: 'NYU' },
  { target: 'bytedance', altText: 'Bytedance' },
  { target: 'amazon', altText: 'Amazon' },
]

export const customerLogos = [
  { target: 'character-ai', altText: 'Character AI' },
  { target: 'wander', altText: 'Wander' },
  { target: 'thiel-fellowship', altText: 'Thiel Fellowship' },
  { target: 'hf0', altText: 'HF0' },
  { target: 'latch-bio', altText: 'Latch Bio' },
  { target: 'atob', altText: 'AtoB' },
  { target: 'monad', altText: 'Monad' },
  { target: 'formation', altText: 'Formation' },
]
